import PropTypes from 'prop-types';
import React from 'react';

import { SeatedContext } from '../../../context/seatedContext';

import MapSelection from './map/mapSelection2';
import { Message } from 'semantic-ui-react';

import InventoryPicker from '../../../components/contingent/inventoryPicker';

import { Trans } from 'react-i18next';

import '../../../styles/attendees/map-selector.css';

export default class AttendeesMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentZone: null,
            reloader: 0
        };
    }

    componentDidMount() {
        this.props.removeScrollListener();
        this.props.onActionDone(this.onActionDone.bind(this));
    }

    onActionDone(action, selectedAttendees) {
        // reload inventory if needed
        this.setState({
            reloader: this.state.reloader + 1
        });

        if (this.props.deselectAllAttendees && action.name === 'swap') {
            this.props.deselectAllAttendees();
        }

        return Promise.resolve();
    }

    /**
     * Renders selection step on map
     */
    renderMap() {
        if (window.innerWidth < 480) {
            return (
                <Message>
                    <Trans i18nKey="noResponsiveDesignAvailable">Sorry, this page can only be seen from a desktop computer</Trans>
                </Message>
            );
        }

        return (
            <MapSelection
                sync={this.state.reloader}
                history={this.props.history}
                attendees={this.props.attendees}
                selectedAttendees={this.props.selectedAttendees}
                selectAttendees={this.props.selectAttendees}
                deselectAttendees={this.props.deselectAttendees}
                inventory={this.context.seatedContext.inventory}
                onAttendeeSelected={this.props.onAttendeeSelected}
            />
        );
    }

    render() {
        return (
            <div className="attendees-map">
                <InventoryPicker
                    inventories={this.context.seatedContext.inventories}
                    currentInventory={this.context.seatedContext.inventory}
                    onChange={this.context.setInventory}
                />
                <div className="attendee-map-selector">{this.renderMap()}</div>
            </div>
        );
    }
}

AttendeesMap.contextType = SeatedContext;

AttendeesMap.propTypes = {
    attendees: PropTypes.array.isRequired,
    connectData: PropTypes.object.isRequired,
    contingents: PropTypes.object,
    currentInventory: PropTypes.object,
    deselectAttendees: PropTypes.func.isRequired,
    deselectAllAttendees: PropTypes.func,
    event: PropTypes.object,
    getAllContingents: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    inventories: PropTypes.array,
    onAttendeeClick: PropTypes.func.isRequired,
    onAttendeeSelected: PropTypes.func.isRequired,
    onActionDone: PropTypes.func.isRequired,
    organizationId: PropTypes.string.isRequired,
    removeScrollListener: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array,
    selectOne: PropTypes.func.isRequired,
    selectAttendees: PropTypes.func.isRequired
};
